import { SearchUserEnriched } from 'lib-search-types';

export type PresenceStatus = 'working' | 'away' | 'offline';

export const getStatus = (member: SearchUserEnriched): PresenceStatus =>
  member.is_online ? (member.is_working ? 'working' : 'away') : 'offline';
